import React, { useContext } from "react";
import { images } from "../Assets/images";
import { GlobalContext } from "../Context/GlobalContext";

const WeightSlider = ({ value, onChange }) => {
    const { translatedLabels } = useContext(GlobalContext);
    const authLabel = translatedLabels?.auth;
    const min = 100;
    const max = 350;

    const ticks = [];
    for (let i = min; i <= max; i += 6) {
        ticks.push(i);
    }

    return (
        <div className="weight-slider-container">
            <div className="d-flex justify-content-between align-items-center">
                <label className="form-label question-label mb-0">{authLabel?.what_is_your_weight?.label_value || "What is your weight?"} <span className="text-danger">*</span></label>
                <span className="text-muted">{value} lbs</span>
            </div>
            <div className="d-flex align-items-center gap-2">
                <div className="input-image">
                    <img src={images.weight} alt="weight" />
                </div>

                <div className="w-100">
                    <div className="position-relative">
                        <input
                            type="range"
                            min={min}
                            max={max}
                            step="1"
                            value={value}
                            onChange={(e) => onChange(Number(e.target.value))}
                            className="weight-slider"
                            style={{
                                "--progress": `${((value - min) / (max - min)) * 100}%`,
                            }}
                        />

                        <div className="slider-ticks">
                            {ticks.map((tick, i) => {
                                let heightClass = "small-tick";

                                if (tick % 50 === 0) heightClass = "large-tick"; // every 50 lbs
                                else if (tick % 20 === 0) heightClass = "medium-tick"; // every 20 lbs

                                return <div key={i} className={`tick-mark ${heightClass}`} />;
                            })}
                        </div>
                    </div>

                    <div className="d-flex justify-content-between tick-labels mt-2">
                        {[100, 150, 200, 250, 300, 350].map((lbs) => (
                            <span key={lbs} className="tick-label">
                                {lbs} lbs
                            </span>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WeightSlider;